import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getProjectById, updateProject } from "../../services/api"; // Funciones para obtener y actualizar el proyecto
import Breadcrumbs from "../../components/BreadCrumbs";

const ProjectUpdate = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [projectData, setProjectData] = useState({
    nombre: "",
    descripcion: "",
    fecha_inicio: "",
    fecha_fin: "",
    estado: "",
  });

  useEffect(() => {
    const fetchProject = async () => {
      try {
        const response = await getProjectById(id);
        setProjectData(response);
      } catch (error) {
        console.error("Error al obtener el proyecto", error);
      }
    };

    fetchProject();
  }, [id]);

  const handleChange = (e) => {
    setProjectData({
      ...projectData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateProject(id, projectData);
      navigate("/dashboard/projects"); // Redirige a la lista de proyectos después de la actualización
    } catch (error) {
      console.error("Error al actualizar el proyecto", error);
    }
  };

  const handleBack = () => {
    navigate("/dashboard/projects"); // Navega de regreso al listado de proyectos
  };

  // Definir las rutas para los breadcrumbs
  const breadcrumbPaths = [
    { name: "Dashboard", url: "/dashboard" },
    { name: "Proyectos", url: "/dashboard/projects" },
    { name: "Editar Proyecto", url: "/dashboard/projects/update" },
  ];

  return (
    <>
      <Breadcrumbs paths={breadcrumbPaths} />
      <h3>Actualizar Proyecto</h3>
      <form onSubmit={handleSubmit}>
        <div className="mb-3 row">
          <label className="col-sm-2 col-form-label">Nombre del Proyecto</label>
          <div class="col-sm-10">
            <input
              type="text"
              className="form-control"
              name="nombre"
              value={projectData.nombre}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="mb-3 row">
          <label className="col-sm-2 col-form-label">Descripción</label>
          <div class="col-sm-10">
            <textarea
              className="form-control"
              name="descripcion"
              value={projectData.descripcion}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="mb-3 row">
          <label className="col-sm-2 col-form-label">Fecha de Inicio</label>
          <div class="col-sm-10">
            <input
              type="date"
              className="form-control"
              name="fecha_inicio"
              value={projectData.fecha_inicio}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="mb-3 row">
          <label className="col-sm-2 col-form-label">Fecha de Fin</label>
          <div class="col-sm-10">
            <input
              type="date"
              className="form-control"
              name="fecha_fin"
              value={projectData.fecha_fin}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="mb-3 row">
          <label className="col-sm-2 col-form-label">Estado</label>
          <div class="col-sm-10">
            <select
              className="form-select"
              name="estado"
              value={projectData.estado}
              onChange={handleChange}
              required
            >
              <option value="">Seleccionar...</option>
              <option value="Nuevo">Nuevo</option>
              <option value="En progreso">En Progreso</option>
              <option value="Finalizado">Finalizado</option>
              <option value="En espera">En espera</option>
            </select>
          </div>
        </div>
        <div style={{ textAlign: "end" }}>
          <button type="submit" className="btn btn-primary">
            Actualizar Proyecto
          </button>

          <button
            type="button"
            className="btn btn-secondary ms-3"
            onClick={handleBack}
          >
            Regresar
          </button>
        </div>
      </form>
    </>
  );
};

export default ProjectUpdate;
